import HttpClient from "../helpers/HttpClient"
import PriceList, {DuplicatePriceListDto, PriceListDto} from "./PriceList"
import {AppContext} from "@lightspeed-invoicing/core-client/frontend"

type PayLoadPriceList = {
    title: string,
    objectType: string,
    creditMemoContactReceiverId: string,
    docGeneratedStatus: string,
}

class PriceListService {
    static httpClient: HttpClient<PriceList, PriceListDto> = new HttpClient<PriceList, PriceListDto>(PriceList)

    static async update(id: string, payload: object) {
        return this.httpClient.patch("/price-lists/" + id, payload)
    }

    static async get(id: string) {
        return this.httpClient.get("/price-lists/" + id)
    }

    static async CreatePriceList(payload: PayLoadPriceList) {
        return this.httpClient.post("/price-lists", payload)
    }

    static async CreatePriceListFromEvent(title: string, objectType: string, eventID: string) {
        return this.httpClient.post(`/events/${eventID}/price-lists`, {
            objectType: objectType,
            title: title,
        })
    }

    static async CreatePriceListFromOrder(title: string, orderID: string, creditMemoContactReceiverId: string) {
        return this.httpClient.post(`/orders/${orderID}/price-lists`, {
            title: title,
            creditMemoContactReceiverId: creditMemoContactReceiverId,
        })
    }

    static async DuplicatePriceList(priceListId: string, data: DuplicatePriceListDto) {
        return this.httpClient.post(`/price-lists/${priceListId}/duplicate`, data)
    }

    static async StartBulkCreate(priceListId, payload) {
        return AppContext.getApiClient().post(`/price-lists/${priceListId}/bulk-create-orders`, payload)
    }

    static async applyBulkDiscount(id: string, payload: object) {
        return this.httpClient.put(`/price-lists/${id}/bulk-discount`, payload)
    }

    static async applyBulkUpdate(id: string, payload: object) {
        return this.httpClient.patch(`/price-lists/${id}/bulk-update`, payload)
    }

}

export default PriceListService


// WEBPACK FOOTER //
// ./src/state/price-list/PriceListService.ts